import { UserGoal } from 'src/common/enums';

export const goalTitles = new Map<UserGoal, string>([
  [UserGoal.EVALUTE_THM, 'DISCOVER THE PLATFORM THAT POWERS TEAM GROWTH'],
  [UserGoal.GAIN_FUNDAMENTAL_SKILLS, 'LEARN CYBERSECURITY FROM THE GROUND UP'],
  [UserGoal.GET_JOB_CYBER, 'SECURE THE SKILLS FOR YOUR DREAM CYBER JOB'],
  [UserGoal.JUST_LOOKING_AROUND, 'LEVEL UP YOUR LEARNING THIS SUMMER'],
  [UserGoal.MASTER_NEW_SKILL, 'INVEST IN THE SKILLS THAT SHAPE YOUR FUTURE'],
  [UserGoal.TRAIN_TEAM, 'SHARPEN YOUR SKILLS, LEAD WITH CONFIDENCE'],
  [UserGoal.UPSKILL_FIELD, 'MASTER THE SKILLS THAT SET YOU APART'],
]);
